import React from 'react';

export default React.forwardRef<
    HTMLAnchorElement,
    React.ClassAttributes<HTMLAnchorElement> & React.AnchorHTMLAttributes<HTMLAnchorElement>
>((props: React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>, ref) => {
    return (
        <a
            {...props}
            ref={ref}
            href="#0"
            onClick={ev => {
                ev.preventDefault();
                props.onClick?.(ev);
            }}>
            {props.children}
        </a>
    );
});
